const Index = () => import('./components/index.vue');

export default [
  {
    path: '/pedidos',
    name: 'orders.index',
    meta: {
      title: 'Pedidos',
    },
    component: Index,
  },
];
